import type { WritableComputedRef } from 'vue'
import useStringCookie from '../modules/ab-testing/useStringCookie'

export default (cookieName: string) => {
  const current = ref<string>()

  const cookie = useStringCookie(cookieName)
  const encodedValue = cookie.get()

  if (encodedValue) {
    current.value = decodeURIComponent(encodedValue)
  }

  return computed({
    get() {
      return current.value
    },
    set(value: string | undefined) {
      current.value = value

      const encodedValue = value ? encodeURIComponent(value) : value
      cookie.set(encodedValue)
    },
  }) as WritableComputedRef<string | undefined>
}
